import React, { useState, useEffect, useMemo } from 'react'
import { Form, Input } from 'semantic-ui-react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { mapDateRangeToDays } from '../../../../utils/mappers/analytics'
import { changeLoadSimulationData, changeSimTransitStockArrival } from '../../../../actions/analytics-v2'
import { getSafeSelectedWorkspace } from '../../../../utils/mappers/user'
import _ from "lodash" 
import "./TransitStockArrivalModifier.css"

const TransitStockArrivalModifier = 
({ 
    changeSimTransitStockArrival,
    simulationTransitStockArr,
    dateRange, 
    disabled,
    loadSimulationData,
    simulationMaterialData,
    complementaryInfo,
    currentWorkspaceId,
    changeLoadSimulationData 
})=>{


    const { t } = useTranslation()
    const { loaded_results="", sim_inputs="" } = loadSimulationData[0] || {}
    let transitStockArrival = useMemo(()=>{
        return sim_inputs.transit_stock_arrival ? sim_inputs.transit_stock_arrival : simulationTransitStockArr
    }, [sim_inputs, simulationTransitStockArr])

    const [ TransitStockArrival, setTransitStockArrival ] = useState(
        transitStockArrival);

    const filterTransitStockArrival = (transitStockArrivalD) => {
        if(_.isEmpty(transitStockArrivalD)){
            return ''
        }
        const maxTransitStockArrival = mapDateRangeToDays(dateRange.startDateRange, dateRange.endDateRange);
        const allowedTransitStockArrival = parseInt(transitStockArrivalD) <= maxTransitStockArrival ?
         parseInt(transitStockArrivalD) : maxTransitStockArrival; 
        return Math.abs(allowedTransitStockArrival)
    }

    useEffect(()=>{
        setTransitStockArrival(transitStockArrival)
        !_.isEmpty(complementaryInfo) && _.isNil(simulationTransitStockArr)? 
        changeSimTransitStockArrival(parseInt(complementaryInfo.supply_lead_time)) 
        : changeSimTransitStockArrival(transitStockArrival)

    }, [
        setTransitStockArrival, 
        simulationTransitStockArr,
        changeSimTransitStockArrival, 
        simulationMaterialData, 
        transitStockArrival, 
        currentWorkspaceId, 
        complementaryInfo
    ])
    
    const memSupplyLeadTime = useMemo(() => {
        if(_.isEmpty(complementaryInfo)){
            return '-'
        } 
        return complementaryInfo.supply_lead_time
    }, [complementaryInfo])
    const memMateialTag = useMemo(() => simulationMaterialData.name, [simulationMaterialData])
    useEffect(()=> {
        // used when material is changed to set default value in input
        setTransitStockArrival(memSupplyLeadTime === '-'? memSupplyLeadTime: parseInt(memSupplyLeadTime))
        changeSimTransitStockArrival(memSupplyLeadTime === '-'? null: parseInt(memSupplyLeadTime))
    },[memSupplyLeadTime, memMateialTag, setTransitStockArrival, changeSimTransitStockArrival])


    const setNewTransitStockArrival = () => {
        if(TransitStockArrival === '' || TransitStockArrival === 0){
            changeSimTransitStockArrival(transitStockArrival)
            return
        }
        if(loadSimulationData.length){
            changeLoadSimulationData([{loaded_results,
                sim_inputs: {...sim_inputs, transit_stock_arrival: TransitStockArrival}}])
            return
        }
        changeSimTransitStockArrival(TransitStockArrival)
    }
    
    return(
            <Form.Field>
                <label 
                    className="field-title">
                    {t("simulation.transitStockArrival")}
                </label>
                <Input
                    className='transit-stock-mod-input'
                    disabled={disabled}
                    onBlur={() => setNewTransitStockArrival()}
                    value={TransitStockArrival}
                    onChange={(e)=>{setTransitStockArrival(filterTransitStockArrival(e.target.value))}}
                    />
            </Form.Field>
    )
}

TransitStockArrivalModifier.propTypes = {
    changeSimAduFreqUpd: PropTypes.func,
    changeSimTransitStockArrival: PropTypes.func,
    simulationTransitStockArr: PropTypes.number,
    dateRange: PropTypes.object,
    disabled: PropTypes.bool,
    loadSimulationData: PropTypes.array,
    simulationMaterialData: PropTypes.object,
    complementaryInfo: PropTypes.object,
    currentWorkspaceId: PropTypes.number,
    changeLoadSimulationData: PropTypes.func,
}

const mapStateToProps = (state)=>({
    simulationTransitStockArr: state.analytics.simulationTransitStockArr,
    loadSimulationData: state.analytics.loadSimulationData,
    simulationMaterialData: state.analytics.simulationMaterialData,
    complementaryInfo: state.analytics.complementaryInfo,
    currentWorkspaceId: getSafeSelectedWorkspace(state),
})

export default connect(mapStateToProps,{ changeLoadSimulationData, changeSimTransitStockArrival })(TransitStockArrivalModifier)